import React, { useEffect } from "react";
import 'styles/main/Footer.sass'


export default function Footer(props) {

  useEffect(() => { 
    console.log('render Footer')
  });

  return (
    <div id="footer">
      <div id="logoFooter" />
      <div id="links">
        <a href="https://marine.copernicus.eu/privacy-policy" target="_blank">Privacy Policy</a>
        <a href="https://marine.copernicus.eu/legal-notice" target="_blank">Legal Notice</a>
      </div>
    </div>
  )
}